module.exports = __webpack_public_path__ + "img/logo.17d2d1ae.png";